import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ap-input-skeleton',
    templateUrl: './input-skeleton.component.html',
    styleUrls: ['./input-skeleton.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ApInputSkeletonComponent {}
